import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { MatMenuModule } from "@angular/material/menu";
import { RouterModule } from "@angular/router";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  standalone: true,
  selector: "cell-link",
  templateUrl: "cell-link.component.html",
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    RouterModule,
    CommonModule,
  ],
})
export class CellLinkComponent implements ICellRendererAngularComp {
  userId!: string;
  params!: ICellRendererParams;
  queryParams?: { [key: string]: string };
  showToolTip: boolean = true;
  inlineStyles = {};
  disableNavigation = false;
  /** Explains why the value is not a link (shown on hover when navigation is disabled). */
  disabledTooltip: string | null = null;
  customClass: string = "";
  data!: any;
  constructor() {}
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.queryParams =
      this.params.colDef?.cellRendererParams?.queryParams || null;
    if (this.params.colDef?.cellRendererParams?.showToolTip === false) {
      this.showToolTip = false;
    }
    if (this.params.colDef?.cellRendererParams?.inlineStyles) {
      this.inlineStyles = this.params.colDef?.cellRendererParams?.inlineStyles;
    }
    this.customClass =
      this.params.colDef?.cellRendererParams?.customClass || "";
    this.resolveNavigationState();
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    if (this.params.colDef?.cellRendererParams?.showToolTip === false) {
      this.showToolTip = false;
    }
    this.resolveNavigationState();
    return true;
  }

  private resolveNavigationState(): void {
    const rendererParams = this.params.colDef?.cellRendererParams;
    this.disableNavigation = !!this.resolveRowOption(rendererParams?.disableNavigation);
    this.disabledTooltip = this.resolveRowOption(rendererParams?.disabledTooltip) || null;
  }

  /** `disableNavigation` and `disabledTooltip` are a value for the whole column, or a function deciding per row. */
  private resolveRowOption<T>(option: T | ((row: any) => T)): T {
    return typeof option === "function"
      ? (option as (row: any) => T)(this.params.data)
      : option;
  }
  onClick(): void {
    this.params.colDef?.cellRendererParams?.clicked(
      this.params.data,
      this.params.rowIndex
    );
  }
}
